import { useEffect, useState } from 'react';
import './Socials.css';
import { XEmbed } from 'react-social-media-embed';

function Socials() {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        if (window.bluesky) {
            window.bluesky.scan();
        }
    }, [currentSlide]);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % 2);
        }, 10000); // Switch every 10 seconds

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="socials-container">
            <div className="slider-container">
                <div className={`slide ${currentSlide === 0 ? 'active' : ''}`}>
                    <XEmbed url="https://x.com/re_base_studio/status/1969728488333570375" width={325} />
                </div>
                <div className={`slide ${currentSlide === 1 ? 'active' : ''}`}>
                    <blockquote className="bluesky-embed" data-bluesky-uri="at://did:plc:av6jfjnn6isr4qojdvdcruo3/app.bsky.feed.post/3lzdstwewtc27" data-bluesky-cid="bafyreigsas2heko7y34zswsovxmug52ctzctkvb463pt46kukw7lkmlr5y" data-bluesky-embed-color-mode="dark">
                        <p lang="en">tryna make a crt shader but this fella keeps wanting to play games on my phone #godot<br /><br />
                            <a href="https://bsky.app/profile/did:plc:av6jfjnn6isr4qojdvdcruo3/post/3lzdstwewtc27?ref_src=embed">[image or embed]</a></p>
                        &mdash; RE:BASE (<a href="https://bsky.app/profile/did:plc:av6jfjnn6isr4qojdvdcruo3?ref_src=embed">@re-base.bsky.social</a>)
                        <a href="https://bsky.app/profile/did:plc:av6jfjnn6isr4qojdvdcruo3/post/3lzdstwewtc27?ref_src=embed">Sep 21, 2025 at 1:42 PM</a>
                    </blockquote>
                </div>
            </div>
            <div className="steam-widget" style={{ verticalAlign: "top" }}>
                <iframe src="https://store.steampowered.com/widget/3354950/" frameBorder="0" width="646" height="190" title='steam'></iframe>
            </div>
        </div>
    );
}

export default Socials;